// extracted by mini-css-extract-plugin
export var wrapper = "PlayApp-module_wrapper__3DTcy";
export var contentWrap = "PlayApp-module_contentWrap__39RNZ";
export var container = "PlayApp-module_container__1fQJ5";
export var blogStyles = "PlayApp-module_blogStyles__V6mos";
export var columnWrapper = "PlayApp-module_columnWrapper__1mksq";
export var exploreAnimotoWrap = "PlayApp-module_exploreAnimotoWrap__3_PHY";
export var videoWrapperWrap = "PlayApp-module_videoWrapperWrap__Vq96F";
export var videoWrapper = "PlayApp-module_videoWrapper__4Lyv7";
export var landscape = "PlayApp-module_landscape__auRKc";
export var square = "PlayApp-module_square__2eFbn";
export var vertical = "PlayApp-module_vertical__3Yv9j";
export var details = "PlayApp-module_details__1v7a_";
export var blog = "PlayApp-module_blog__-Iwmp";